import React, { Component } from 'react';
import { get } from '../../../shared/http/request';
import update from 'immutability-helper';
import {
    Alert,
    Button,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Panel,
    Row,
} from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import queryString from 'query-string';
import Select from 'react-select';
import { createPlanningKPIBreadcrumb } from '../../../shared/utils/breadcrumbs';

const API_BASE_URL = 'api/reports';

class PlanningKPI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            routeEvents: [],
            search: {
                routeEvents: [{label :'All', value : 'All'}],
                runDateFrom: '',
                runDateTo: '',
            },
            errors: {},
        };
    }

    componentDidMount() {
        get(`${API_BASE_URL}/route-events`).then(
            resp => {
                this.setState({
                    routeEvents: resp.routeEvents.map(e => ({
                        value: e,
                        label: e,
                    })),
                });
            },
            error => console.log('Error while getting route events', error)
        );
    }

    handleChange = e => {
        this.setState({
            search: update(this.state.search, {
                [e.target.name]: { $set: e.target.value },
            }),
        });
    };

    handleDateChange = name => date => {
        this.setState({
            search: update(this.state.search, {
                [name]: { $set: date },
            }),
        });
    };

    /*handleSelectChange = name => value => {
        let selectedValues = value.split(',');
        this.setState(() => ({
            search: update(this.state.search, {
                [name]: { $set: selectedValues },
            }),
        }));
    };*/

    handleSelectChange = name => value => {

        /*
        console.log(value);

        let selectedValues = value;

        if(undefined != value1 && Array.isArray(value1) && 0 < value1.length){
            value1.map(function(e1){
                selectedValues.push(e1);
                return null;
            })
        } 
        console.log(selectedValues);
        let selectedValues = value.split(',');
        */
        // this.setState(() => ({
        //     search: update(this.state.search, {
        //         [name]: { $set: value },
        //     }),
        // }));
        let selectedValues = [];
        if (Array.isArray(value) && value.length > 0 && undefined != value) {
            selectedValues = value.map(e1 => ({ label : e1.label,
                                                value : e1.value}));
        }
        console.log(selectedValues);
        this.setState(() => ({
            search: update(this.state.search, {
                routeEvents: { $set: selectedValues },
            }),
        }));
    };

    isValidRange = (from, to) => {
        const duration = moment.duration(moment(to).diff(moment(from)));
        return Math.abs(duration.asDays()) <= 45;
    };

    validateForm = e => {
        const { search } = this.state;
        let errors = {};
        if (search.runDateFrom === '' || search.runDateTo === '') {
            errors.datesRequired = 'Route dates are required';
        } else if (!this.isValidRange(search.runDateFrom, search.runDateTo)) {
            errors.dateRange = 'The max. range between from and to is 45 days';
        }

        if (Object.keys(errors).length > 0) {
            this.setState(() => ({ errors }));
            e.preventDefault();
        }
    };

    prepareFormDataForPost = form => {
        const search = update(form, {
             routeEvents: {
                $set: form.routeEvents.map(e => e.value),
            },
            runDateFrom: {
                $set: form.runDateFrom ? moment(form.runDateFrom).format('YYYY-MM-DD') : '',
            },
            runDateTo: {
                $set: form.runDateTo ? moment(form.runDateTo).format('YYYY-MM-DD') : '',
            },
        });
        return queryString.stringify(search);
    };

    render() {
        const { search, routeEvents, errors } = this.state;
        return (
            <Col sm={12}>
                {createPlanningKPIBreadcrumb()}
                <Form horizontal>
                    <Row>
                        <Col sm={6} className="no-gutter">
                            <Panel header="Timeframe">
                                <FormGroup controlId="from">
                                    {errors.datesRequired && (
                                        <Alert bsStyle="danger">{errors.datesRequired}</Alert>
                                    )}
                                    {errors.dateRange && (
                                        <Alert bsStyle="danger">{errors.dateRange}</Alert>
                                    )}
                                    <Col sm={4} componentClass={ControlLabel}>
                                        From *
                                    </Col>
                                    <Col sm={8}>
                                        <Datetime
                                            value={search.runDateFrom}
                                            onChange={this.handleDateChange('runDateFrom')}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat={false}
                                            inputProps={{
                                                maxLength: 255,
                                                placeholder: '...',
                                            }}
                                            closeOnSelect
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="to">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        To *
                                    </Col>
                                    <Col sm={8}>
                                        <Datetime
                                            value={search.runDateTo}
                                            onChange={this.handleDateChange('runDateTo')}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat={false}
                                            inputProps={{
                                                maxLength: 255,
                                                placeholder: '...',
                                            }}
                                            closeOnSelect
                                        />
                                    </Col>
                                </FormGroup>
                            </Panel>
                            <Panel header="Route">
                                <FormGroup controlId="routeCode">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Route Code
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl
                                            type="text"
                                            placeholder="..."
                                            name="routeCode"
                                            value={search.routeCode}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="runSequence">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Run Sequence
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl
                                            type="text"
                                            placeholder="..."
                                            name="runSequence"
                                            value={search.runSequence}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="routeEvents">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Route Events
                                    </Col>
                                    <Col sm={8}>
                                        {routeEvents &&
                                            routeEvents.length > 0 && (
                                                <Select
                                                    value={search.routeEvents}
                                                    options={routeEvents}
                                                    placeholder="..."
                                                    isMulti
                                                  //  simpleValue
                                                   // joinValues
                                                    delimiter=","
                                                    onChange={this.handleSelectChange(
                                                        'routeEvents'
                                                    )}
                                                />
                                            )}
                                    </Col>
                                </FormGroup>
                            </Panel>
                            <Panel header="Logistics">
                                <FormGroup controlId="lpCode">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Logistics Point Code
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl
                                            type="text"
                                            placeholder="..."
                                            name="lpCode"
                                            value={search.lpCode}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="plantCode">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Logistics Point Plant Code
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl
                                            type="text"
                                            placeholder="..."
                                            name="plantCode"
                                            value={search.plantCode}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="dockCode">
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Logistics Point Dock Code
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl
                                            type="text"
                                            placeholder="..."
                                            name="dockCode"
                                            value={search.dockCode}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                </FormGroup>
                            </Panel>
                        </Col>
                        <Col sm={12} className="no-gutter">
                            <p>
                                <strong>
                                    Last 45 days downloadable. Fields marked with * are required.
                                </strong>
                            </p>
                        </Col>
                        <Col sm={12}>
                            <FormGroup controlId="submit">
                                <Button
                                    bsStyle={'success'}
                                    onClick={this.validateForm}
                                    href={`${API_BASE_URL}/download-planning-report/FTS_Planning_KPI_${moment().format(
                                        'DD_MM_YYYY-H_mm'
                                    )}?${this.prepareFormDataForPost(this.state.search)}`}
                                >
                                    Download KPI report
                                </Button>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Col>
        );
    }
}

export default PlanningKPI;
